import React, { useState } from "react";
import { Nav as MNav } from "@magnetic/nav";
import { Flex } from "@cisco/spaces-dash-lib-styleguide";
import { Search } from "@magnetic/search";
import NavDrawerItemGroup from "./nav-drawer-item-group";
import NavDrawerItem from "./nav-drawer-item";

function NavDrawerContent({ drawer, i18nNamespace, i18n, basePath, navItemClick, disableItems }) {
  const { density = "comfy", drawerId, heading, isSwitcher = false, groups = [], items = [] } = drawer;

  const [search, setSearch] = useState("");

  let filteredItems = items;
  if (isSwitcher && search) {
    filteredItems = items.filter((item) => {
      return item.text.toLowerCase().includes(search.toLowerCase());
    });
  }

  const headingText = i18n?.t(heading, { ns: i18nNamespace }) || heading;
  console.log("NavDrawerContent filteredItems -----", filteredItems);
  console.log("NavDrawerContent -----", groups);

  return (
    <MNav.Drawer.Content density={density} id={drawerId} heading={headingText} itemGroupSpacing={groups?.length > 0 ? 32 : undefined}>
      {isSwitcher && (
        <Flex direction="vertical" gap={8} id={`search-for-${drawerId}`} style={{ marginBottom: "12px" }}>
          <Search label="" options={[]} placeholder="Search" value={search} onChange={(e) => setSearch(e.target.value)} onClear={() => setSearch("")} />
        </Flex>
      )}
      {groups &&
        groups.map((group) => {
          return <NavDrawerItemGroup key={group.id} group={group} i18nNamespace={i18nNamespace} i18n={i18n} basePath={basePath} navItemClick={navItemClick} />;
        })}

      {filteredItems
        .filter((i) => !disableItems.includes(i.id))
        .map((item) => (
          <NavDrawerItem key={item.id} item={item} i18nNamespace={i18nNamespace} i18n={i18n} basePath={basePath} navItemClick={navItemClick} />
        ))}
    </MNav.Drawer.Content>
  );
}

export default NavDrawerContent;
